// extracted by mini-css-extract-plugin
export default {"productGrid":"I0-z","centerLink":"J0-z","productSection":"K0-z","item":"L0-z","ctaButton":"M0-z"};